/*
 * @Author: dali
 * @Date: 2022-08-29 09:53:21
 * @LastEditors: 陈威达
 * @LastEditTime: 2024-09-20 14:48:55
 * @FilePath: \gerlun-react-website\src\pages\head-bar\index.jsx
 * @Description:
 */
import wrapWithUser from '@/components/wrapWithUser'
import logo from '../../common/images/pageHome/logo.png'
import yd_logo from '../../common/images/pageHome/yd-logo.png'
import view_list from '../../common/images/icon/view-list.png'
import headset from '../../common/images/pageHome/headset.png'
import styles from './index.scss'
import { Menu, Dropdown, Modal } from 'antd'
import React, { Fragment, useEffect, useState, useRef } from 'react'
import UserForm from '@/components/userForm'
import ModifyInfo from '@/components/modifyInfo'
import Org from '@/components/org'
import { SYSCON } from '@/const/const'
import IconFont from '@/common/Icons'
import User from '../../modules/user'
import { DownOutlined, MenuOutlined, CloseOutlined, UserOutlined } from '@ant-design/icons'
import { useNavigate, useLocation } from 'react-router-dom'
import { ExclamationCircleFilled } from '@ant-design/icons'
import ChangePwd from '@/components/loginForm/changePwd'
import ForgetPassword from '@/components/forgetPassword'
import { openIM } from '@/utils/im'
const { confirm } = Modal

const HeadBar = (props) => {
  const userRef = React.createRef()
  const modifyRef = React.createRef()
  const orgRef = React.createRef()
  const navigate = useNavigate()
  const location = useLocation()
  const [loadStatu, handleLoadStatu] = useState(false)
  const [expand, setExpand] = useState(true)
  const [expand_x, setExpand_x] = useState(true)
  const [isSmall, handleIsSmall] = useState(false)
  const [data, setData] = useState([])
  const height = window.innerHeight
  const user = new User()
  const query = {
    pageSize: 4,
    pageNum: 1,
    articleName: '',
    releaseColumn: '手机案例',
    releaseColumnId: ''
  }
  const componentDidMount = ()=>{
    setData([])
    user.getArticleList(query)
      .then(res => {
        setData(res.result)
      })
      .catch((res) => {
        setData([])
        console.log(res)
      })
  }
  const accountingIndustryClients = useRef('财税行业客户')
  const consultingIndustryClients = useRef('咨询行业客户')
  const enterpriseCustomers = useRef('企业客户')
  const accountantExperience = useRef('会计师体验')
  // 初始化
  useEffect(()=>{
    componentDidMount()
    async function initUser() {
      await props.user.initUserInfo().catch((err)=>{
        console.log('err', err)
      })
      // 密码强度为弱时 && 账号为登录状态时
      if (localStorage.getItem(SYSCON.GelFinanceChangePws) === 'true' && props.user.getLoginStatu()) {
        handleChangePwd()
      } else {
        localStorage.removeItem(SYSCON.GelFinanceChangePws)
      }
      handleLoadStatu(true)
      props.setStatu(props.user.getLoginStatu())
    }
    initUser()
    judgeInviterCode()
  }, [])

  const callPhone = () => {
    window.location.href = 'tel://057486261037'
  }

  const changePwdRef = React.createRef()
  const handleChangePwd = () => {
    changePwdRef.current.open()
  }
  const forgetRef = React.createRef()

  // 关闭弹窗
  const handleForgetClick = () => {
    forgetRef.current.open()
  }

  const judgeActiveMenu = (path) => {
    let pathMap = []
    const { pathname } = location
    pathMap.push(path)
    if (path === '/sol') {
      pathMap = pathMap.concat(['/sol-bill', '/sol-apply', '/sol-operation', '/sol-appreciation', '/sol-wealth'])
    }
    if (path === '/serve') {
      pathMap = pathMap.concat(['/standard', '/era-account', '/popularize', '/advanced', '/advanced-era', '/cloud'])
    }
    if (path === '/case') {
      pathMap = pathMap.concat(['/case-dtl'])
    }
    return pathMap.includes(pathname)
  }

  // 导航工作台
  const handleToWorkSta = () => {
    const user = new User()
    user.getRootOrgs().then((res) => {
      console.log(res)
      window.location.href = (`${process.env.REACT_APP_WORK_URL}?token=${localStorage.getItem(SYSCON.Token)}&appCatCd=${SYSCON.PlatAppWorkbench}`)
    })
      .catch(err => {
        console.log(err)
      })
  }
  const handleLoginOut = async() => {
    await props.user.loginOut()
    props.setStatu(props.user.getLoginStatu())
  }

  const handleModify = () => {
    modifyRef.current.open()
  }

  const handleLogin = (inviterCode) => {
    console.log(inviterCode, 'inviterCode')
    userRef.current.open(inviterCode)
  }

  const handleNaviProduct = () => {
    /*
      点击【进入系统】逻辑
        1、 判断当前用户是否已经登录，如果没有登录，则自动弹出登录弹窗，输入用户名和密码后进入系统；如果已经登录，则直接进入系统。
        2、 进入系统逻辑如下：
          1） 如果用户有默认组织，直接选定默认组织，进入系统
          2） 如果用户第一次登录，没有选择过默认组织，且用户只有一个组织，则直接选定这个组织，进入系统
          3） 如果用户第一次登录，没有选择默认组织，且用户有两个或者两个以上的组织，则跳出组织选择界面，选择后，进入系统
          4） 进入系统的逻辑同前，即如果组织只有报销系统，则进入报销系统，否则进入财务系统
    */
    const user = new User()
    const token = localStorage.getItem(SYSCON.Token)
    if (!token) {
      handleLogin('enter')
      return
    }
    user.getRootOrgs().then((data) => {
      console.log('orgsssss', data)
      if (!data || data.length === 0) {
        confirm({
          title: '提示',
          icon: <ExclamationCircleFilled />,
          content: '您还未购买或试用任何产品，请跳转到工作台进行购买和试用',
          okText: '是',
          cancelText: '否',
          onOk() {
            handleToWorkSta()
          },
          onCancel() {
            console.log('Cancel')
          }
        })
        return
      }
      if (data && data.length === 1) {
        // 首次登录且只有一个组织默认选择这个组织进入系统
        const orgInfo = {
          orgId: data[0].id,
          orgNm: data[0].nm
        }
        handleOrgChoosed(orgInfo)
        return
      }
      const orgId = localStorage.getItem('orgId')
      if (orgId) {
        const org = data.find(item => item.id === orgId)
        if (org) {
          const orgInfo = {
            orgId: org.id,
            orgNm: org.nm
          }
          handleOrgChoosed(orgInfo)
          return
        } else {
          orgRef.current.open()
        }
      }
      orgRef.current.open()
    })
      .catch((err) => console.log('err', err))
  }
  const handleOrgChoosed = (org) => {
    console.log('chooseorg', org)
    const user = new User()
    user.getProductDetail(org.orgId).then((data) => {
      console.log('prodssss', data)
      const finProd = data.activatedList.find(item => item.prodCd === SYSCON.PlatAppSmarterFin)
      const expProd = data.activatedList.find(item => item.prodCd === SYSCON.PlatAppExpense)
      const token = localStorage.getItem(SYSCON.Token)
      if (finProd) {
        handleNaviFin(finProd, token, org)
        return
      }
      if (expProd) {
        handleNaviExpense(token, org)
        return
      }
      if (!finProd || !expProd) {
        confirm({
          title: '提示',
          icon: <ExclamationCircleFilled />,
          content: '您还未购买财务或者报销系统，请前往购买或者试用',
          okText: '是',
          cancelText: '否',
          onOk() {
            handleGoto('/product-choose')
          },
          onCancel() {
            console.log('Cancel')
          }
        })
        return
      }
    })
      .catch((err) => console.log('err', err))
  }
  const handleNaviExpense = (userToken, org) => {
    const token = userToken
    const orgId = org.orgId
    const orgNm = org.orgNm
    if (orgId && orgNm) {
      const url = `${process.env.REACT_APP_EXPENSE_BASE_URL}/#/start?token=${token}&orgId=${orgId}&orgNm=${orgNm}`
      window.open(url)
    }
  }
  const handleNaviFin = (item, userToken, org) => {
    const token = userToken
    const orgId = org.orgId
    const orgNm = org.orgNm
    console.log('url', item)
    // 限定只有财务系统跳转
    if (item.prodCd === SYSCON.PlatAppSmarterFin || item.prodCd === SYSCON.PlatAppInvoice) {
      let baseUrl = process.env.REACT_APP_BASE_URL
      baseUrl = `${baseUrl}/#/start`
      const invoiceFlg = item.prodCd === SYSCON.PlatAppInvoice
      if (invoiceFlg) {
        const financeProd = this.activatedList.find(item => item.prodCd === SYSCON.PlatAppSmarterFin)
        if (!financeProd) {
          this.$message.warning('无法进入，请先购买财务系统，并设置开票员角色')
          return
        }
      }
      const url = `${baseUrl}?token=${token}&orgId=${orgId}&orgNm=${orgNm}&invoiceFlg=${invoiceFlg ? '1' : ''}`
      console.log({ url })
      window.open(url)
    }
  }
  const handleNavigate = (path) => {
    window.scrollTo({
      top: 0
    })
    console.log(path)
    navigate(path)
    if (!expand) {
      setExpand(!expand)
    }
    if (!expand_x) {
      setExpand_x(!expand_x)
    }
    if (isSmall) {
      handleIsSmall(!isSmall)
    }
  }

  // const handleScrollTo = (id) => {
  //   const portalEle = document.getElementById(id)
  //   console.log('portalEle', portalEle)
  //   if (portalEle) {
  //     window.scrollTo({
  //       top: portalEle.offsetTop - 60,
  //       behavior: 'smooth'
  //     })
  //   }
  // }
  // 登录成功回调
  const handleLoginSuccess = (code) => {
    if (code === 'enter') {
      handleNaviProduct()
    }
  }

  const handleGoto = (path) => {
    window.scrollTo({
      top: 0
    })
    navigate(path)
  }

  const judgeInviterCode = () => {
    // TODO
    const res = window.location.href.match(/\?code=([\d\w]*)/)
    let inviterCode = ''
    if (res) {
      inviterCode = res[1]
    }
    if (inviterCode) {
      handleLogin(inviterCode)
    }
  }

  const handleSkip = (name) => {
    const obj = {
      'bookkeepingServices': '宁波**财税服务集团有限公司',
      'consultation': '四川沃沃**有限公司',
      'enterprise': '中国**连锁店',
      'accountant': '纸箱公司财务总监'
    }
    const nmObj = data.find(item => item.articleName === obj[name])
    if (nmObj) {
      window.scrollTo({
        top: 0
      })
      navigate('/case-dtl/' + nmObj.id)
      if (isSmall) {
        handleIsSmall(!isSmall)
      }
    }
  }
  const pMenu = (
    <Menu className={ styles['names'] }>
      <Menu.Item>
        <a target='_blank' rel='noopener noreferrer' onClick={() => handleNavigate('/sol-bill')} >
         票据管理
        </a>
      </Menu.Item>
      <Menu.Item>
        <a target='_blank' rel='noopener noreferrer' onClick={() => handleNavigate('/sol-apply')} >
        报销管理
        </a>
      </Menu.Item>
      <Menu.Item>
        <a target='_blank' rel='noopener noreferrer' onClick={() => handleNavigate('/sol-operation')} >
        运营管理
        </a>
      </Menu.Item>
      <Menu.Item>
        <a target='_blank' rel='noopener noreferrer' onClick={() => handleNavigate('/sol-appreciation')} >
        特色增值
        </a>
      </Menu.Item>
      <Menu.Item>
        <a target='_blank' rel='noopener noreferrer' onClick={() => handleNavigate('/sol-wealth')} >
        智能财税
        </a>
      </Menu.Item>
    </Menu>
  )
  const menu = (
    <Menu>
      <Menu.Item>
        <a target='blank' rel='noopener noreferrer' onClick={() => handleToWorkSta()}>
          <UserOutlined /> 用户中心
        </a>
      </Menu.Item>
      <Menu.Item>
        <a target='_blank' rel='noopener noreferrer' onClick={() => handleModify()}>
          <IconFont className={styles['icon-link-item']} type='icon-bianji'/> 用户信息修改
        </a>
      </Menu.Item>
      <Menu.Item>
        <a target='_blank' rel='noopener noreferrer' onClick={() => handleLoginOut()} >
          <IconFont className={styles['icon-link-item']} type='icon-tuichu1'/> 退出登录
        </a>
      </Menu.Item>
    </Menu>
  )
  const style_x = {
    width: '120px'
  }
  return (
    <Fragment>
      <div className={`${styles['page_home_head']} top-head`}>
        <div className={`${styles.page_home_head2} ${styles.w1250}`}>
          <div className={styles['page-home-lt']}>
            <div className={styles['page-home-logo']} onClick={() => handleNavigate('/')}>
              <a href='/#' onClick={(e) => e.preventDefault()}><img src={logo} alt='logo' /></a>
            </div>
            <ul className={styles['page-home-list']}>
              <li className={judgeActiveMenu('/') ? styles['active'] : ''}><a href='/#' onClick={(e) => handleNavigate('/') || e.preventDefault()}>首页</a></li>
              <li className={judgeActiveMenu('/sol') ? styles['active'] : ''}>
                <Dropdown overlay={pMenu} onVisibleChange={(expand) => { setExpand(!expand) }} overlayStyle={ style_x }
                >
                  <a href='/#' onClick={(e) => e.preventDefault()}>解决方案 {expand ? <DownOutlined style={{ transition: 'all .2s linear' }}/> : <DownOutlined style={{ transition: 'all .2s linear', transform: 'rotate(180deg)' }}/>}</a>
                </Dropdown>
              </li>
              <li className={judgeActiveMenu('/serve') ? styles['active'] : ''}><a href='/#' onClick={(e) => handleNavigate('/serve') || e.preventDefault()}>产品中心</a></li>
              <li className={judgeActiveMenu('/case') ? styles['active'] : ''} onClick={() => handleNavigate('/case')}>
                {/* <Dropdown overlay={sMenu} onVisibleChange={(expand_x) => { setExpand_x(!expand_x) }}> */}
                <a href='/#' onClick={(e) => e.preventDefault()} >成功案例</a>
                {/* </Dropdown> */}
              </li>
              <li className={judgeActiveMenu('/video-center') ? styles['active'] : ''}><a href='/#' onClick={(e) => handleNavigate('/video-center') || e.preventDefault()}>视频中心</a></li>
              <li className={judgeActiveMenu('/info') ? styles['active'] : ''}><a href='/#' onClick={(e) => handleNavigate('/info') || e.preventDefault()}>行业资讯</a></li>
              <li className={judgeActiveMenu('/aboutus') ? styles['active'] : ''}><a href='/#' onClick={(e) => handleNavigate('/aboutus') || e.preventDefault()}>关于我们</a></li>
            </ul>
          </div>
          <div className={styles['page-home-rt']}>
            { loadStatu ? (props.loginStatu ? (
              <Fragment>
                <div className={styles['page-home-order']}>
                  <a href='/#' onClick={(e) => handleGoto('/product-choose') || e.preventDefault()}>在线购买</a>
                  <a target='_blank' rel='noopener noreferrer' onClick={() => handleNaviProduct()}>进入系统</a>
                </div>
                <Dropdown overlay={menu} trigger={['hover']}>
                  <div>
                    <IconFont className={styles['icon-item']} type='icon-yonghu'/>
                    <span className={styles['user-name']} title={props.user.getUserName()}>{props.user.getUserName()}</span>
                  </div>
                </Dropdown>
              </Fragment>) : (
              <Fragment>
                <div className={styles['page-home-order']}><a href='/#' onClick={(e) => handleGoto('/product-choose') || e.preventDefault()}>在线购买</a></div>
                <div className={styles['page-home-order']}><a target='_blank' rel='noopener noreferrer' onClick={() => handleNaviProduct()}>进入系统</a></div>
                <div><a href='/#' onClick={() => handleLogin()}>登录</a></div>
              </Fragment>
            )) : ''}
          </div>
        </div>
        {/* max: 767头部 */}
        <div className={styles['page-home-top']}>
          <div className={styles['logo']}><img src={yd_logo} alt='yd_logo' /></div>
          <div className={styles['list']}>
            {!isSmall ? <MenuOutlined style={{ fontSize: '20px' }} onClick={() => handleIsSmall(!isSmall) || setExpand_x(true) || setExpand(true) }/> : <CloseOutlined style={{ fontSize: '20px' }} onClick={() => handleIsSmall(!isSmall)}/>}
            {isSmall && <ul>
              <li onClick={() => handleNavigate('/')}><a href='/#' onClick={(e) => e.preventDefault()}>首页</a></li>
              <li onClick={() => { setExpand(!expand) || setExpand_x(true) }}>
                <a href='/#' onClick={(e) => e.preventDefault()}>解决方案</a>
                {expand ? <DownOutlined style={{ transition: 'all .2s linear', fontSize: '14px' }} /> : <DownOutlined style={{ transition: 'all .2s linear', transform: 'rotate(180deg)', fontSize: '14px' }} />}
                {!expand && <ul>
                  <li onClick={() => handleNavigate('/sol-bill')}>
                    <a target='_blank' rel='noopener noreferrer'>
                    票据管理
                    </a>
                  </li>
                  <li onClick={() => handleNavigate('/sol-apply')}>
                    <a target='_blank' rel='noopener noreferrer'>
                    报销管理
                    </a>
                  </li>
                  <li onClick={() => handleNavigate('/sol-operation')}>
                    <a target='_blank' rel='noopener noreferrer' >
                    运营管理
                    </a>
                  </li>
                  <li onClick={() => handleNavigate('/sol-appreciation')}>
                    <a target='_blank' rel='noopener noreferrer' >
                    特色增值
                    </a>
                  </li>
                  <li onClick={() => handleNavigate('/sol-wealth')}>
                    <a target='_blank' rel='noopener noreferrer' >
                    智能财税
                    </a>
                  </li>
                </ul>}
              </li>
              <li onClick={() => handleNavigate('/serve')}><a href='/#' onClick={(e) => e.preventDefault()}>产品中心</a></li>
              <li onClick={() => { setExpand_x(!expand_x) || setExpand(true) }}>
                <a href='/#' onClick={(e) => e.preventDefault()}>成功案例</a>
                {expand_x ? <DownOutlined style={{ transition: 'all .2s linear', fontSize: '14px' }} /> : <DownOutlined style={{ transition: 'all .2s linear', transform: 'rotate(180deg)', fontSize: '14px' }} />}
                {!expand_x && <ul>
                  <li onClick={() => handleSkip('bookkeepingServices')}>
                    <a target='_blank' rel='noopener noreferrer'>
                      {accountingIndustryClients.current}
                    </a>
                  </li>
                  <li onClick={() => handleSkip('consultation')}>
                    <a target='_blank' rel='noopener noreferrer' >
                      {consultingIndustryClients.current}
                    </a>
                  </li>
                  <li onClick={() => handleSkip('enterprise')}>
                    <a target='_blank' rel='noopener noreferrer' >
                      {enterpriseCustomers.current}
                    </a>
                  </li>
                  <li onClick={() => handleSkip('accountant')}>
                    <a target='_blank' rel='noopener noreferrer' >
                      {accountantExperience.current}
                    </a>
                  </li>
                </ul>}
              </li>
              <li onClick={() => handleNavigate('/video-center')}><a href='/#' onClick={(e) => e.preventDefault()}>视频中心</a></li><li onClick={() => handleNavigate('/info')}><a href='/#' onClick={(e) => e.preventDefault()}>行业资讯</a></li>
              <li onClick={() => handleNavigate('/aboutus')}><a href='/#' onClick={(e) => e.preventDefault()}>关于我们</a></li>
              <li className={styles['page-home-order']} onClick={() => callPhone()}>
                <div><img src={view_list} alt='view_list' /></div>
                0574-<i>8626 1037</i>
              </li>
              <li className={styles['page-home-order']} onClick={() => openIM()}>
                <div className={styles['page-noboder']}><img src={headset} alt='headset' style={{ height: '20px' }} /></div>
                在线咨询
              </li>
            </ul>}
          </div>
        </div>
        {isSmall && <div className={styles['mask']} style={{ height: height }} onClick={() => { handleIsSmall(false) }}></div>}
      </div>
      <UserForm onRef={userRef} handleLoginSuccess={handleLoginSuccess} />
      <ModifyInfo onRef={modifyRef}/>
      <Org onRef={orgRef } handleOrgChoosed={handleOrgChoosed}/>
      <ForgetPassword onRef={forgetRef} />
      <ChangePwd onRef={changePwdRef} handleForgetClick={handleForgetClick} setStatu={props.setStatu} />
    </Fragment>
  )
}

export default wrapWithUser(HeadBar)
